import React from 'react'
import './styles.css'
import SvgIcon, { iconList } from '../../../share/components/iconSVG'
import imgClinic from '../../../../assets/pictures/img-3.webp'

const InfoDetailDoctor = ({ infoDoctor, infoSpecialist, offices, urlImage, specialist }) => {
    return (
        <div className='contain-info-detail-doctor'>
            <section className='detalle-info-doctor-p'>
                <h3>Informacion</h3>
                <p>
                    {infoDoctor}
                </p>
                <h3>Especialidad</h3>
                <p>
                    {infoSpecialist}
                </p>
            </section>
            <section className='list-detalle-especialidades'>
                <h3>Especialidades</h3>
                <div className='list-detalle-especialidades-layout'>
                    <ul>
                        {
                            specialist.map((item,key)=>{
                                return(
                                    <li key={key}><SvgIcon name={iconList.IconCheckSucces} size={30} color={'#004274'} />{item.name}</li>
                                )
                            })
                        }
                    </ul>
                </div>
                <h3>Oficinas</h3>
                {
                    offices.map((item, key) => {
                        return (
                            <div className='office-work-doctor' key={key}>
                                <div className='office-work-doctor-header'>
                                    <img src={`${urlImage}${item.image}`} alt="img" />
                                    <div>
                                        <h4>{item.name}</h4>
                                        <p>
                                            <span>Ciudad:</span> {item.city.name}
                                        </p>
                                        <p>
                                            <span>Direccion:</span> {item.address}
                                        </p>
                                    </div>
                                </div>

                                <div className='office-work-doctor-main'>
                                    <h4>Descripcion:</h4>
                                    <p>
                                       {item.description}
                                    </p>

                                </div>
                            </div>
                        )
                    })
                }

            </section>
        </div>
    )
}

export default InfoDetailDoctor